export default "__VITE_PUBLIC_ASSET__18d284ab__"